export type BoxRef = { row: number; col: number };
export const boxRefEquals = (a: BoxRef, b: BoxRef) => a.row === b.row && a.col === b.col;
